<div class="overlay-inner-wrapper">
  @if (!isInspektion) {
    <header class="header-2">
      <div class="branding">
        <span class="title">{{ titel | mrTranslate }}</span>
      </div>
      <div class="header-actions">
        @if (typ_Line_Point | objtype: 'line') {
          <a href="javascript:void(0);" class="nav-link nav-icon" (click)="openCodesVerwaltung()">
            <cds-icon shape="cog" />
          </a>
        }
        <a href="javascript:void(0);" class="nav-link nav-icon" (click)="close()">
          <cds-icon shape="times" />
        </a>
      </div>
    </header>
  }

  <div
    id="spezifikationsWrapper"
    class="w-100-p padding-10-lr padding-12-b scroll-y"
    [ngClass]="isInspektion ? 'h-100' : 'h-60'">
    @if (typ_Line_Point | objtype: 'line') {
      <div class="d-f col h-100 w-100-p">
        <div class="clr-row nxm clr-justify-content-between clr-align-items-center margin-12-tb">
          @if (source == 'Inspektion') {
            <div class="clr-col-auto" style="height: auto">
              <span class="label" [class]="isComplete ? 'label-success' : 'label-danger'">
                <cds-icon
                  [shape]="isComplete ? 'success-standard' : 'error-standard'"
                  solid="true"
                  class="margin-6-r"
                  style="fill: currentColor" />
                <span class="text">
                  {{ 'Vollständigkeit' | mrTranslate }} {{ startmeter | number: '.0-2' }} -
                  {{ endmeter | number: '.0-2' }}
                </span>
              </span>
            </div>
          }
          <div class="clr-col-auto clr-row nxm clr-align-items-center">
            <clr-toggle-container clrInline class="margin-0-t clr-col-auto">
              <clr-toggle-wrapper>
                <label>
                  <cds-icon shape="add-text" />
                  {{ 'Smart Einfügen' | mrTranslate }}
                </label>
                <input
                  type="checkbox"
                  clrToggle
                  name="insert"
                  [disabled]="!setInsert"
                  [(ngModel)]="isSmartInsert"
                  [ngModelOptions]="{ standalone: true }" />
              </clr-toggle-wrapper>
            </clr-toggle-container>
            <div class="btn-group btn-primary btn-icon clr-col-auto">
              <button
                class="btn btn-icon btn-success"
                [title]="'Neu' | mrTranslate"
                (click)="addSpez()"
                [disabled]="setInsert">
                <cds-icon shape="file" />
              </button>
              <button
                class="btn btn-icon btn-danger"
                [title]="'Löschen' | mrTranslate"
                (click)="deleteSpezLine()"
                [disabled]="!selectedSpez">
                <cds-icon shape="times" />
              </button>
              <button
                class="btn btn-icon margin-12-l"
                [title]="'Speichern' | mrTranslate"
                [clrLoading]="saveState()"
                (click)="ngForm().ngSubmit.emit()"
                [disabled]="!(selectedSpez || setInsert)">
                <cds-icon shape="floppy" />
              </button>
            </div>
          </div>
        </div>
        <!-- Top-Sektion - Felder zum eintragen -->
        <form
          [formGroup]="formSpezTop"
          ngForm
          (ngSubmit)="saveIfValid()"
          [clrLabelSize]="12"
          clrForm
          clrLayout="vertical"
          class="width100 float-buttons padding-12-lr margin--15-t">
          @if (formSpezTop.errors?.['not-in-Direction']; as err) {
            <div class="clr-row nxm clr-col-12 clr-col-sm-10 clr-col-md-8 clr-col-lg-6">
              <clr-alert class="w-100-p" clrAlertType="danger" [clrAlertClosable]="false">
                <clr-alert-item>
                  <span class="alert-text">
                    {{
                      'Der Startmeter muss ' + (err.upwards ? 'kleiner' : 'größer') + ' als der Endmeter sein'
                        | mrTranslate
                    }}
                  </span>
                </clr-alert-item>
              </clr-alert>
            </div>
          }
          <div class="clr-row nxm">
            <ng-container *ngTemplateOutlet="!drehung.isOn ? start : end" />
            <ng-container *ngTemplateOutlet="!drehung.isOn ? end : start" />
            <ng-template #start>
              <div class="clr-col-lg-2 clr-col-md-3 clr-col-sm-4 clr-col-6">
                <clr-number-input-container>
                  <label>
                    <span class="clr-required-mark">
                      {{ (!drehung.isOn ? 'Startmeter' : 'Endmeter') | mrTranslate }}
                    </span>
                    <div class="btn-group btn-sm btn-icon btn-outline btn-float">
                      <button
                        class="btn"
                        type="button"
                        [title]="'Geoposition orten' | mrTranslate"
                        tabindex="-1"
                        (click)="findPositionAndAutofill('Startmeter')"
                        [disabled]="formSpezTop.disabled"
                          [clrLoading]="geoState()">
                        <cds-icon shape="map-marker" />
                      </button>
                    </div>
                  </label>
                  <input
                    clrNumberInput
                    formControlName="Startmeter"
                    [value]="formSpezTop.get('Startmeter').value | drehung: drehung.summe"
                    (change)="
                      formSpezTop.get('Startmeter').setValue(drehungPipe.back($event.target.value, drehung.summe))
                    "
                    name="Startmeter"
                    type="number"
                    [step]="0.1" />
                  <clr-control-error *clrIfError="'required'">
                    {{ 'Erforderlich' | mrTranslate }}
                  </clr-control-error>
                  @if (formSpezTop.controls.Startmeter.errors?.min; as err) {
                    <clr-control-error>
                      {{ 'Der Wert ist ' + (!drehung.isOn ? 'kleiner' : 'größer') + ' als' | mrTranslate }}
                      {{ err.min | drehung: drehung.summe }}
                    </clr-control-error>
                  }
                  @if (formSpezTop.controls.Startmeter.errors?.max; as err) {
                    <clr-control-error>
                      {{ 'Der Wert ist ' + (!drehung.isOn ? 'größer' : 'kleiner') + ' als' | mrTranslate }}
                      {{ err.max | drehung: drehung.summe }}
                    </clr-control-error>
                  }
                </clr-number-input-container>
              </div>
            </ng-template>
            <ng-template #end>
              <div class="clr-col-lg-2 clr-col-md-3 clr-col-sm-4 clr-col-6">
                <clr-number-input-container>
                  <label>
                    <span class="clr-required-mark">
                      {{ (!drehung.isOn ? 'Endmeter' : 'Startmeter') | mrTranslate }}
                    </span>
                    <div class="btn-group btn-sm btn-icon btn-outline btn-float">
                      <button
                        class="btn"
                        type="button"
                        [title]="'Geoposition orten' | mrTranslate"
                        tabindex="-1"
                        (click)="findPositionAndAutofill('Endmeter')"
                        [disabled]="formSpezTop.disabled"
                          [clrLoading]="geoState()">
                        <cds-icon shape="map-marker" />
                      </button>
                    </div>
                  </label>
                  <input
                    clrNumberInput
                    formControlName="Endmeter"
                    [value]="formSpezTop.get('Endmeter').value | drehung: drehung.summe"
                    (change)="
                      formSpezTop.get('Endmeter').setValue(drehungPipe.back($event.target.value, drehung.summe))
                    "
                    name="Endmeter"
                    type="number"
                    [step]="0.1" />
                  <clr-control-error *clrIfError="'required'">
                    {{ 'Erforderlich' | mrTranslate }}
                  </clr-control-error>
                  @if (formSpezTop.controls.Endmeter.errors?.min; as err) {
                    <clr-control-error>
                      {{ 'Der Wert ist ' + (!drehung.isOn ? 'kleiner' : 'größer') + ' als' | mrTranslate }}
                      {{ err.min | drehung: drehung.summe }}
                    </clr-control-error>
                  }
                  @if (formSpezTop.controls.Endmeter.errors?.max; as err) {
                    <clr-control-error>
                      {{ 'Der Wert ist ' + (!drehung.isOn ? 'größer' : 'kleiner') + ' als' | mrTranslate }}
                      {{ err.max | drehung: drehung.summe }}
                    </clr-control-error>
                  }
                </clr-number-input-container>
              </div>
            </ng-template>
            @if (typ_Line_Point == 4) {
              <div class="clr-col-lg-2 clr-col-md-3 clr-col-sm-4 clr-col-6">
                <clr-input-container>
                  <label class="clr-required-mark">{{ 'Code' | mrTranslate }}</label>
                  <input
                    clrInput
                    formControlName="Code"
                    name="code"
                    [tabIndex]="-1"
                    type="text"
                    style="pointer-events: none; cursor: default" />
                  <clr-control-error *clrIfError="'required'">
                    {{ 'Wählen Sie eine Vorlage aus' | mrTranslate }}
                  </clr-control-error>
                </clr-input-container>
              </div>
            }
            @for (option of spezOpt; track option) {
              <div class="clr-col-lg-2 clr-col-md-3 clr-col-sm-4 clr-col-6">
                @switch (option.fieldType) {
                  @case ('str') {
                    @if (option.sField) {
                      <!-- ! STRIKT Texteingabefeld nur vom Tabelle -->
                      <clr-select-container>
                        <label style="text-wrap: nowrap; text-overflow: ellipsis; overflow: hidden">
                          <span [class.clr-required-mark]="!!option.pflichtFeld">
                            {{ option.objekt | mrTranslate }}
                          </span>
                          <div class="btn-group btn-sm btn-icon btn-float">
                            <button
                              class="btn"
                              type="button"
                              [title]="'Liste bearbeiten' | mrTranslate"
                              tabindex="-1"
                              (click)="openTabelle(option)">
                              <cds-icon shape="note" />
                            </button>
                          </div>
                        </label>
                        <select
                          clrSelect
                          [inTableValidator]="option.wListe"
                          [required]="!!option.pflichtFeld"
                          [formControlName]="option.objekt"
                          [name]="option.objekt">
                          @let value = formSpezTop?.value[option.objekt];
                          <option [disabled]="option.pflichtFeld" value=""></option>
                          @if (value && !option.wListe.includes(value)) {
                            <option [value]="value" class="invalid-red">{{ value }}</option>
                          }
                          @for (wert of option.wListe; track wert) {
                            <option [value]="wert">{{ wert }}</option>
                          }
                        </select>
                        <clr-control-error *clrIfError="'not-in-Table'; error as err">
                          {{ err | mrTranslate }}
                        </clr-control-error>
                        <clr-control-error *clrIfError="'required'">
                          {{ 'Erforderlich' | mrTranslate }}
                        </clr-control-error>
                      </clr-select-container>
                    } @else {
                      <!-- * FREI Texteingabefeld mit den bisherigen Werten -->
                      <clr-control-container>
                        <label
                          style="text-wrap: nowrap; text-overflow: ellipsis; overflow: hidden"
                          [class.clr-required-mark]="!!option.pflichtFeld">
                          {{ option.objekt | mrTranslate }}
                        </label>
                        <app-datalist-input
                          [datalist]="option.wListe"
                          placeholder=""
                          [formControlName]="option.objekt" />
                        <clr-control-error *clrIfError="'required'">
                          {{ 'Erforderlich' | mrTranslate }}
                        </clr-control-error>
                      </clr-control-container>
                    }
                  }
                  <!-- Zahleneingabefeld number -->
                  @case ('dbl') {
                    <ng-container *ngTemplateOutlet="numberControlName; context: { float: true }" />
                  }
                  @case ('int') {
                    <ng-container *ngTemplateOutlet="numberControlName; context: { float: false }" />
                  }
                  <!-- Ja/Nein Einegabe -->
                  @case ('chk') {
                    <clr-toggle-container>
                      <label style="text-wrap: nowrap; text-overflow: ellipsis; overflow: hidden">
                        {{ option.objekt | mrTranslate }}
                      </label>
                      <clr-toggle-wrapper>
                        <input type="checkbox" clrToggle [name]="option.objekt" [formControlName]="option.objekt" />
                      </clr-toggle-wrapper>
                    </clr-toggle-container>
                  }
                  <!-- Datum -->
                  @case ('dat') {
                    <clr-date-container>
                      <label
                        style="text-wrap: nowrap; text-overflow: ellipsis; overflow: hidden"
                        [class.clr-required-mark]="!!option.pflichtFeld">
                        {{ option.objekt | mrTranslate }}
                      </label>
                      <input
                        clrDate
                        [name]="option.objekt"
                        autocomplete="off"
                        type="date"
                        [ngModel]="formSpezTop.controls[option.objekt].value | localeDate"
                        (ngModelChange)="formSpezTop.controls[option.objekt].setValue(localeDate.tosql($event))"
                        [ngModelOptions]="{ updateOn: 'blur', standalone: true }"
                        [disabled]="formSpezTop.disabled"
                        [required]="!!option.pflichtFeld" />
                      <clr-control-error *clrIfError="'required'">
                        {{ 'Erforderlich' | mrTranslate }}
                      </clr-control-error>
                    </clr-date-container>
                  }
                }
                <ng-template #numberControlName let-float="float">
                  <clr-number-input-container>
                    <label
                      style="text-wrap: nowrap; text-overflow: ellipsis; overflow: hidden"
                      [class.clr-required-mark]="!!option.pflichtFeld">
                      {{ option.objekt | mrTranslate }}
                    </label>
                    <input
                      clrNumberInput
                      [name]="option.objekt"
                      type="number"
                      [formControlName]="option.objekt"
                      [step]="float ? 0.1 : 1"
                      [required]="!!option.pflichtFeld" />
                    <clr-control-error *clrIfError="'required'">
                      {{ 'Erforderlich' | mrTranslate }}
                    </clr-control-error>
                  </clr-number-input-container>
                </ng-template>
              </div>
            }
          </div>
        </form>
        @if (table) {
          <clr-datagrid
            #spezTableGrid
            class="datagrid-compact dg-overflow-fix"
            [clrDgSelectionType]="'single'"
            [clrDgSelected]="[selectedSpez]"
            (clrDgSelectedChange)="selectedSpez = $event[0]"
            [clrDgRowSelection]="true"
            [clrDgItemsIdentityFn]="trackByOSPEZID"
            [style.maxHeight]="typ_Line_Point == 4 ? '25svh' : 'none'">
            <clr-dg-column
              [clrDgField]="(!drehung.isOn ? 'Startmeter' : 'Endmeter') + '.value'"
              [clrDgSortOrder]="direction * (drehung.isOn ? -1 : 1)">
              {{ 'Startmeter' | titlecase | mrTranslate }}
            </clr-dg-column>
            <clr-dg-column [clrDgField]="(!drehung.isOn ? 'Endmeter' : 'Startmeter') + '.value'">
              {{ 'Endmeter' | titlecase | mrTranslate }}
            </clr-dg-column>
            @for (column of table.columns | array: 'filter' : exceptStartEnd; track column) {
              <clr-dg-column [clrDgField]="column.id + '.value'">
                <ng-container *clrDgHideableColumn="{ hidden: column.id | hideIDColumns }">
                  {{ column.id | titlecase | mrTranslate }}
                </ng-container>
              </clr-dg-column>
            }
            <clr-dg-row *clrDgItems="let row of table.rows" [clrDgItem]="row">
              <clr-dg-cell class="name-cell">
                {{ row[!drehung.isOn ? 'Startmeter' : 'Endmeter']?.value | drehung: drehung.summe | tablePrettyPrint }}
              </clr-dg-cell>
              <clr-dg-cell class="name-cell">
                {{ row[!drehung.isOn ? 'Endmeter' : 'Startmeter']?.value | drehung: drehung.summe | tablePrettyPrint }}
              </clr-dg-cell>
              @for (cell of table.columns | array: 'filter' : exceptStartEnd; track cell) {
                <clr-dg-cell class="name-cell">{{ row[cell.id]?.value | tablePrettyPrint }}</clr-dg-cell>
              }
            </clr-dg-row>
            <clr-dg-footer>{{ table.rows?.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
          </clr-datagrid>
        }
        @if (table && tableTmpl && typ_Line_Point == 4) {
          <clr-datagrid
            #templateTableGrid
            class="datagrid-compact dg-overflow-fix fill-space"
            [clrDgSelectionType]="'single'"
            [clrDgSelected]="[selectedTmpl]"
            (clrDgSelectedChange)="selectedTmpl = $event[0]"
            [clrDgRowSelection]="!!(selectedSpez || setInsert)">
            @for (column of tableTmpl.columns; track column) {
              <clr-dg-column [clrDgField]="column.id">
                <ng-container
                  *clrDgHideableColumn="{
                    hidden:
                      column.id
                      | hideIDColumns
                        : ['bild64', 'schienenformid', 'schwellenartid', 'schienenbefestigungid', 'eindeckungid'],
                  }">
                  {{ column.id | mrTranslate | titlecase }}
                </ng-container>
              </clr-dg-column>
            }
            <clr-dg-row
              *clrDgItems="let row of tableTmpl.rows"
              [clrDgItem]="row"
              [clrDgSelectable]="!!selectedSpez || setInsert"
              id="t-{{ row.Bezeichnung }}">
              @for (cell of tableTmpl.columns; track cell) {
                <clr-dg-cell class="name-cell">{{ row[cell.id] | tablePrettyPrint }}</clr-dg-cell>
              }
            </clr-dg-row>
            <clr-dg-footer>{{ tableTmpl.rows.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
          </clr-datagrid>
        }
      </div>
    } @else {
      <div class="clr-row nxm">
        <div style="width: 100%; max-width: 1200px; margin: 0 auto">
          <form #spezFormPoint clrForm ngForm (ngSubmit)="saveIfValid()" class="width100 margin-12-t" clrLabelSize="12">
            <table class="table margin-0-t table-compact nowrap">
              <thead style="position: sticky; top: 0; z-index: 3">
                <tr>
                  <th class="left">{{ 'Objekt' | mrTranslate }}</th>
                  <th class="left" style="width: 50%">{{ 'Bezeichnung' | mrTranslate }}</th>
                  <th>{{ 'Tabelle' | mrTranslate }}</th>
                  <th>{{ 'Pflicht' | mrTranslate }}</th>
                </tr>
              </thead>
              <tbody>
                @for (spez of spezData; track spez) {
                  <tr [hidden]="spez.objekt == 'OSPEZID'">
                    @if (!spez.isHeader) {
                      <td class="left">
                        <span [class.clr-required-mark]="!!spez.pflichtFeld">{{ spez.objekt | mrTranslate }}</span>
                      </td>
                      <td class="left">
                        @switch (spez.fieldType) {
                          @case ('str') {
                            @if (spez.sField) {
                              <!-- ! STRIKT Texteingabefeld nur vom Tabelle -->
                              <clr-select-container>
                                <select
                                  clrSelect
                                  [name]="spez.objekt"
                                  [(ngModel)]="spez.bezeichnung"
                                  [required]="!!spez.pflichtFeld"
                                  [inTableValidator]="spez.wListe">
                                  <option [disabled]="spez.pflichtFeld" value=""></option>
                                  @if (spez.bezeichnung && !spez.wListe.includes(spez.bezeichnung)) {
                                    <option [value]="spez.bezeichnung" class="invalid-red">
                                      {{ spez.bezeichnung }}
                                    </option>
                                  }
                                  @for (wert of spez.wListe; track wert) {
                                    <option [value]="wert">{{ wert }}</option>
                                  }
                                </select>
                                <clr-control-error *clrIfError="'not-in-Table'; error as err">
                                  {{ err | mrTranslate }}
                                </clr-control-error>
                                <clr-control-error *clrIfError="'required'">
                                  {{ 'Erforderlich' | mrTranslate }}
                                </clr-control-error>
                              </clr-select-container>
                            } @else {
                              <!-- * FREI Texteingabefeld mit den bisherigen Werten -->
                              <clr-control-container>
                                <app-datalist-input
                                  [datalist]="spez.wListe"
                                  placeholder=""
                                  [name]="spez.objekt"
                                  [(ngModel)]="spez.bezeichnung"
                                  [required]="!!spez.pflichtFeld" />
                                <clr-control-error *clrIfError="'required'">
                                  {{ 'Erforderlich' | mrTranslate }}
                                </clr-control-error>
                              </clr-control-container>
                            }
                          }
                          @case ('dbl') {
                            <!-- Zahleneingabefeld number -->
                            <ng-container *ngTemplateOutlet="numberNgModel; context: { float: true }" />
                          }
                          @case ('int') {
                            <ng-container *ngTemplateOutlet="numberNgModel; context: { float: false }" />
                          }
                          @case ('chk') {
                            <!-- Ja/Nein Einegabe -->
                            <clr-toggle-container class="padding-10-l">
                              <clr-toggle-wrapper>
                                <input type="checkbox" clrToggle [name]="spez.objekt" [(ngModel)]="spez.bezeichnung" />
                              </clr-toggle-wrapper>
                            </clr-toggle-container>
                          }
                          @case ('dat') {
                            <!-- Datum -->
                            <clr-date-container>
                              <input
                                clrDate
                                [name]="spez.objekt"
                                autocomplete="off"
                                type="date"
                                [required]="!!spez.pflichtFeld"
                                [ngModel]="spez.bezeichnung | localeDate"
                                (ngModelChange)="spez.bezeichnung = localeDate.tosql($event)"
                                [ngModelOptions]="{ updateOn: 'blur' }" />
                              <clr-control-error *clrIfError="'required'">
                                {{ 'Erforderlich' | mrTranslate }}
                              </clr-control-error>
                            </clr-date-container>
                          }
                        }
                        <ng-template #numberNgModel let-float="float">
                          <clr-number-input-container>
                            <input
                              clrNumberInput
                              [name]="spez.objekt"
                              [(ngModel)]="spez.bezeichnung"
                              type="number"
                              [step]="float ? 0.1 : 1"
                              [required]="!!spez.pflichtFeld" />
                            <clr-control-error *clrIfError="'required'">
                              {{ 'Erforderlich' | mrTranslate }}
                            </clr-control-error>
                          </clr-number-input-container>
                        </ng-template>
                      </td>
                      <td>
                        @if (spez.sField) {
                          <cds-icon
                            [title]="'Liste bearbeiten' | mrTranslate"
                            shape="note"
                            size="20"
                            (click)="openTabelle(spez)" />
                        }
                      </td>
                      <td>
                        @if (spez.pflichtFeld) {
                          <cds-icon shape="success-standard" solid="true" style="fill: #2ec0ff" />
                        }
                      </td>
                    } @else {
                      <th class="headerRow left">
                        {{ spez.objekt | mrTranslate }}
                      </th>
                      <th class="headerRow"></th>
                      <th class="headerRow"></th>
                      <th class="headerRow"></th>
                    }
                  </tr>
                }
              </tbody>
            </table>
          </form>
          @if (!isInspektion) {
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" (click)="ngForm().ngSubmit.emit()">
                {{ 'Speichern' | mrTranslate }}
              </button>
            </div>
          }
        </div>
      </div>
    }
  </div>
</div>

<clr-modal #notCompleteModal [clrModalSize]="'md'">
  <h3 class="modal-title">{{ 'Spezifikationen sind unvollständig!' | mrTranslate }}</h3>
  <div class="modal-body">
    <p>
      {{ 'Die Spezifikationen müssen das Objekt vollständig umfassen!' | mrTranslate }}
    </p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="notCompleteModal.close()">
      {{ 'Bearbeiten' | mrTranslate }}
    </button>
  </div>
</clr-modal>

<app-baseitems-wrapper
  [(isModalOpen)]="isBaseItemModalOpen"
  [route]="editTabelle()"
  (refreshList)="refreshTabelle($event)" />
